import { render, staticRenderFns } from "./payadvanceMoney.vue?vue&type=template&id=ed68a82e&scoped=true"
import script from "./payadvanceMoney.vue?vue&type=script&lang=js"
export * from "./payadvanceMoney.vue?vue&type=script&lang=js"
import style0 from "./payadvanceMoney.vue?vue&type=style&index=0&id=ed68a82e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed68a82e",
  null
  
)

export default component.exports